import {Component, OnDestroy, OnInit} from '@angular/core';
import {CmsService} from '../../service/cms.service';
import {AuthService} from '../../service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-general-information',
  templateUrl: './general-information.component.html',
  styleUrls: ['./general-information.component.scss']
})
export class GeneralInformationComponent implements OnInit, OnDestroy {

  content: string = 'Általános információk';
  subscriptions: Subscription[] = [];
  isLoggedIn: boolean = false;

  constructor(private cmsService: CmsService, private authService: AuthService) {

    this.subscriptions.push(this.cmsService.generalInformationContent.subscribe((aboutContent: string) => {
      this.content = aboutContent;
    }));


    this.authService.token.subscribe(
      (token) => {
        this.isLoggedIn = !!token;
      }
    );

    this.cmsService.getGeneralInformationContent();
  }

  ngOnInit() {
  }

  onContentSaved(content) {

    this.cmsService.saveGeneralInformationContent(content).subscribe((response) => {
      this.cmsService.generalInformationContentSubject.next(content);
    });

  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

}
